var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawSets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,20H3c-1.65,0-3-1.35-3-3V5c0-1.65,1.35-3,3-3h2c.55,0,1,.45,1,1s-.45,1-1,1h-2c-.55,0-1,.45-1,1v12c0,.55.45,1,1,1h10c.55,0,1-.45,1-1V5c0-.55-.45-1-1-1h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c1.65,0,3,1.35,3,3v12c0,1.65-1.35,3-3,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,6h-2c-1.65,0-3-1.35-3-3S5.35,0,7,0h2c1.65,0,3,1.35,3,3s-1.35,3-3,3ZM7,2c-.55,0-1,.45-1,1s.45,1,1,1h2c.55,0,1-.45,1-1s-.45-1-1-1h-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.01,11c-.55,0-1-.45-1-1s.44-1,1-1h0c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,11h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.01,15c-.55,0-1-.45-1-1s.44-1,1-1h0c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,15h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawSets);
export default __webpack_public_path__ + "static/media/withdraw-sets.ca522fb63b5a7ad52e3e1f2a04e69914.svg";
export { ForwardRef as ReactComponent };